import React from 'react';

import { Skeleton } from '@material-ui/lab';

const LoadingLines: React.FunctionComponent<PropShape> = () => {
    return (
        <div role="progress">
            <Skeleton />
            <Skeleton />
            <Skeleton />
        </div>
    );
};

interface PropShape {}

LoadingLines.defaultProps = {
    // Set default values for props
};

export default LoadingLines;
